import { render, staticRenderFns } from "./opennumberpeople.vue?vue&type=template&id=61058895&scoped=true"
import script from "./opennumberpeople.vue?vue&type=script&lang=js"
export * from "./opennumberpeople.vue?vue&type=script&lang=js"
import style0 from "./opennumberpeople.vue?vue&type=style&index=0&id=61058895&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61058895",
  null
  
)

export default component.exports